module.exports = __webpack_public_path__ + "d964ca7a52e28d4d05b68def17bedddc.svg";